import React, { FunctionComponent } from 'react';
import { IconButton, MenuItem } from '@material-ui/core';
import { Action } from '../../styles';
import BlockIcon from '@material-ui/icons/Block';

type isConfirmType = {
    id: number | undefined;
    name: string;
    open: boolean;
};

type BlockButtonProps = {
    id: number;
    login: string;
    status: boolean;
    setIsBlock: (item: isConfirmType) => void;
    isMe: boolean;
};

function cmp(prev: BlockButtonProps, next: BlockButtonProps): boolean {
    return prev.id === next.id && prev.status === next.status && prev.login === next.login && prev.isMe === next.isMe;
}

const BlockButton: FunctionComponent<BlockButtonProps> = React.memo(({ id, setIsBlock, login, isMe }) => {
    return <MenuItem onClick={() => !isMe && setIsBlock({ id: id, name: login, open: true })} >
        <Action bg={'#919191'} disabled={isMe}>
            <IconButton>
                <BlockIcon fontSize="small" style={{ color: '#fff' }} />
            </IconButton>
        </Action>
    </MenuItem>;
}, cmp);

export default BlockButton;